import React from 'react';
import FieldModal from '../../../../components/modals/fieldModal';
import API from '../../../../utils/API';

class DeleteTicketModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            submitting: false,
            success: false,
            error: null
        };
    }

    deleteTicket = () => {
        const { orgId, programId, flowId, ticket } = this.props;

        this.setState({ submitting: true });

        const payload = {
            request: 'deleteDefaultEventRegistrationFlowTicket',
            registrationFlow: {
                _id: flowId,
                ticketId: ticket._id
            }
        };

        API().patch(`Organizations/${orgId}/programs/${programId}`, payload)
            .then((res) => {
                if (res.data) {
                    this.setState({
                        submitting: false,
                        success: true
                    });

                    if (this.props.onDelete) {
                        this.props.onDelete(ticket._id);
                    }
                } else {
                    console.log('No data in response');
                    this.setState({
                        submitting: false,
                        error: 'Error deleting ticket - no data returned'
                    });
                }
            })
            .catch((err) => {
                console.error('API error:', err);
                this.setState({
                    submitting: false,
                    error: err.response?.data?.message || 'Error deleting ticket'
                });
            });
    };

    render() {
        const { isOpen, toggle, ticket } = this.props;
        const { submitting, success, error } = this.state;

        const ticketName = ticket?.label || 'this ticket';

        return (
            <FieldModal
                size="medium"
                isOpen={isOpen}
                modalTitle="Delete Ticket"
                bodyHeaderText="Are you sure you want to delete this ticket?"
                isDelete={true}
                bodyContent={() => (
                    <div>
                        {error && (
                            <div className="alert alert-danger" role="alert">
                                {error}
                            </div>
                        )}
                        <p>
                            You are about to delete the ticket: <strong>"{ticketName}"</strong>
                        </p>
                        <p>
                            This action cannot be undone. Removing this ticket will prevent attendees from selecting it during registration.
                        </p>
                    </div>
                )}
                toggle={toggle}
                actionButtonLabel={!success ? !submitting ? 'Delete' : 'Deleting...' : 'Deleted'}
                cancelButtonLabel={success ? 'Close' : 'Cancel'}
                actionButton={() => this.deleteTicket()}
                submitting={submitting}
                actionButtonDisabled={submitting || success}
            />
        );
    }
}

export default DeleteTicketModal;
